<template>
  <div
    class="n-card"
    @click="$emit(`click`)"
    :class="{
      clickable,
      depressed,
      absolute,
      'clickable-shadow': clickableShadow,
    }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    clickable: Boolean,
    clickableShadow: Boolean,
    depressed: Boolean,
    absolute: Boolean,
  },
  name: `NCard`,
};
</script>

<style lang="scss" scoped>
  .n-card {
    background-color: #FFF;
    border: 1px solid #DDDDDD;
    // border: 1px solid #E2E2E2;
    // border: 1px solid #DDDDDD;
    border-radius: $contentCardRadius;
    overflow: hidden;
    &:not(.absolute) {
      position: relative;
    }
    &:not(.depressed) {
      border: 1px solid rgba(19, 26, 154, 0.1);
      -webkit-box-shadow: 5px 5px 15px 1px rgba(19, 26, 154, 0.16);
      -moz-box-shadow:    5px 5px 15px 1px rgba(19, 26, 154, 0.16);
      box-shadow:         5px 5px 15px 1px rgba(19, 26, 154, 0.16);
    }

    &.clickable {
      cursor: pointer;
      &:hover {
        background-color: #F3F2FA;
      }
    }
    &.clickable-shadow {
      cursor: pointer;
      &:hover {
        -webkit-box-shadow: 5px 5px 15px 1px rgba(19, 26, 154, 0.35);
        -moz-box-shadow:    5px 5px 15px 1px rgba(19, 26, 154, 0.35);
        box-shadow:         5px 5px 15px 1px rgba(19, 26, 154, 0.35);
      }
    }
  }
</style>
